import ModelState, {localised} from 'spa/state/_util/model';

class PromoState extends ModelState {
  get method() { return 'GET'; }
  get url() { return '/promo-pages'; }
  get singular() { return 'promoPage'; }
  get plural() { return 'promoPages'; }
}

export default PromoState;



// WEBPACK FOOTER //
// ./spa/state/promo-pages.jsx